<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="광고 유입 콜"
        subtitle="광고를 통해 들어온 상담 신청"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 좌측: 요약 정보 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 구매 가능 콜 카드 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-5">
              <div class="flex items-center gap-3 mb-4">
                <div class="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                  <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                  </svg>
                </div>
                <div>
                  <p class="text-[14px] font-bold text-slate-900">구매 가능 콜</p>
                  <p class="text-[12px] text-slate-400">10,000P / 건</p>
                </div>
              </div>
              <div class="flex items-end justify-between">
                <div>
                  <p class="text-[11px] text-slate-400 mb-1">현재 대기</p>
                  <p class="text-[36px] font-black text-blue-600 leading-none">{{ bannerLeads.length }}</p>
                </div>
                <p class="text-[13px] text-slate-400 pb-1">건</p>
              </div>
            </div>

            <!-- 보유 포인트 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-4">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="text-[12px] text-slate-400">보유 포인트</p>
                    <p class="text-[18px] font-black text-blue-600">{{ pointBalance.toLocaleString() }}P</p>
                  </div>
                </div>
                <router-link to="/partners/point" class="text-[12px] font-bold text-blue-600 hover:underline">
                  충전하기
                </router-link>
              </div>
            </div>

            <!-- 안내사항 -->
            <div class="bg-blue-50 border border-blue-200 rounded-2xl p-4">
              <div class="flex gap-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <div>
                  <p class="text-[13px] font-bold text-blue-800 mb-2">광고 유입 콜 안내</p>
                  <ul class="text-[12px] text-blue-700 space-y-1">
                    <li>• <strong>현장점프, 캠페인, 인앱광고, 팝업광고, 스플래시광고, 추천광고, 커뮤니티광고, 꾸우챗광고, 메인배너</strong> 유입 콜</li>
                    <li>• 위 모든 광고를 통해 들어온 콜은 <strong>10,000P</strong>에 구매해야 합니다</li>
                    <li>• 구매 후 고객 연락처가 공개됩니다</li>
                    <li>• <strong>24시간 제한이 없습니다</strong> (언제든 구매 가능)</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- 내 광고 바로가기 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-4">
              <p class="text-[12px] font-bold text-slate-500 mb-3">내 광고 관리</p>
              <div class="space-y-2">
                <router-link to="/partners/jump/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 점프</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/ad/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 캠페인</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/adbanner/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 인앱 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/popup/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 팝업 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/splash/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-cyan-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 스플래시 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/recommend/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 추천 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/communityad/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-slate-200 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 커뮤니티 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link to="/partners/chatad/my" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 꾸우챗 광고</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>

            <!-- 고객 관리 바로가기 -->
            <div class="bg-white border border-slate-200 rounded-2xl p-4">
              <p class="text-[12px] font-bold text-slate-500 mb-3">고객 관리</p>
              <div class="space-y-2">
                <router-link to="/partners/leads/customers" class="flex items-center justify-between p-3 bg-slate-50 rounded-xl hover:bg-slate-100 transition">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                      </svg>
                    </div>
                    <span class="text-[13px] font-medium text-slate-700">내 고객 보관함</span>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>

          <!-- 우측: 콜 리스트 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white border border-slate-200 rounded-2xl p-12 flex flex-col items-center justify-center">
              <div class="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4"></div>
              <p class="text-[14px] text-slate-400">데이터를 불러오는 중...</p>
            </div>

            <!-- 빈 상태 -->
            <div v-else-if="bannerLeads.length === 0" class="bg-white border border-slate-200 rounded-2xl p-12 flex flex-col items-center justify-center">
              <div class="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mb-4">
                <svg class="w-8 h-8 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <p class="text-[15px] font-medium text-slate-500 mb-1">광고 유입 콜이 없습니다</p>
              <p class="text-[13px] text-slate-400 mb-4">광고를 통해 상담 신청이 들어오면 여기에 표시됩니다</p>
              <div class="flex gap-3">
                <router-link to="/partners/adbanner/purchase" class="px-4 py-2 bg-blue-600 text-white text-[13px] font-bold rounded-xl hover:bg-blue-700 transition">
                  인앱 광고 신청
                </router-link>
              </div>
            </div>

            <!-- 콜 목록 -->
            <div v-else class="space-y-3">
              <div class="flex items-center justify-between mb-2">
                <p class="text-[13px] font-bold text-slate-700">광고 유입 콜 목록</p>
                <p class="text-[12px] text-slate-400">총 {{ bannerLeads.length }}건</p>
              </div>

              <div
                v-for="lead in bannerLeads"
                :key="lead.id"
                class="bg-white border border-slate-200 rounded-2xl overflow-hidden"
              >
                <!-- 배너 정보 헤더 -->
                <div :class="[
                  'px-4 py-2 flex items-center justify-between',
                  getLeadHeaderClass(lead)
                ]">
                  <div class="flex items-center gap-2">
                    <span :class="[
                      'px-2 py-0.5 text-[11px] font-bold text-white rounded',
                      getLeadBadgeClass(lead)
                    ]">{{ getLeadBadgeText(lead) }}</span>
                    <span :class="[
                      'text-[13px] font-medium',
                      getLeadTextClass(lead)
                    ]">{{ lead.campaignCode }}</span>
                  </div>
                  <span :class="[
                    'text-[11px]',
                    getLeadLabelClass(lead)
                  ]">{{ getLeadLabel(lead) }}</span>
                </div>

                <!-- 고객 정보 -->
                <div class="p-4">
                  <div class="flex items-center justify-between mb-3">
                    <h3 class="text-[16px] font-bold text-slate-900">{{ maskName(lead.customerName) }}</h3>
                    <span class="px-2.5 py-1 bg-blue-100 text-blue-700 text-[11px] font-bold rounded-lg">
                      {{ lead.propertyName }}
                    </span>
                  </div>

                  <div class="grid grid-cols-2 gap-3 mb-3">
                    <div>
                      <p class="text-[11px] text-slate-400 mb-0.5">연락처</p>
                      <p class="text-[13px] font-medium text-slate-500">{{ maskPhone(lead.customerPhone) }}</p>
                    </div>
                    <div>
                      <p class="text-[11px] text-slate-400 mb-0.5">신청일시</p>
                      <p class="text-[13px] font-medium text-slate-700">{{ formatDate(lead.createdAt) }}</p>
                    </div>
                  </div>

                  <p class="text-[11px] text-slate-400 italic">
                    구매 시 연락처가 공개됩니다.
                  </p>
                </div>

                <!-- 액션 버튼 -->
                <div class="px-4 py-3 bg-slate-50 border-t border-slate-100">
                  <div class="flex items-center justify-between">
                    <div>
                      <p class="text-[11px] text-slate-400">구매 가격</p>
                      <p class="text-[18px] font-black text-blue-600">10,000<span class="text-[12px] font-bold">P</span></p>
                    </div>
                    <button
                      @click="purchaseLead(lead)"
                      :disabled="purchasing === lead.id || pointBalance < 10000"
                      class="flex items-center justify-center gap-2 px-6 py-2.5 bg-blue-600 text-white text-[14px] font-bold rounded-xl hover:bg-blue-700 transition disabled:bg-slate-300"
                    >
                      <span v-if="purchasing === lead.id">구매 중...</span>
                      <span v-else-if="pointBalance < 10000">포인트 부족</span>
                      <span v-else>구매하기</span>
                    </button>
                  </div>
                  <div v-if="pointBalance < 10000" class="mt-2 p-2 bg-red-50 rounded-lg">
                    <p class="text-[12px] text-red-600">
                      포인트가 부족합니다.
                      <router-link to="/partners/point" class="font-bold underline">충전하기</router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 구매 완료 모달 -->
      <div v-if="showSuccessModal" class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
        <div class="bg-white rounded-2xl w-full max-w-md overflow-hidden">
          <div class="p-6 text-center">
            <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <h3 class="text-xl font-bold text-slate-800 mb-2">구매 완료!</h3>
            <p class="text-slate-500 mb-4">고객 연락처가 공개되었습니다.</p>

            <div class="bg-slate-50 rounded-xl p-4 mb-4">
              <div class="text-left space-y-2">
                <div class="flex justify-between">
                  <span class="text-slate-500">고객명</span>
                  <span class="font-semibold text-slate-800">{{ purchasedLead?.customerName }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-slate-500">연락처</span>
                  <a :href="`tel:${purchasedLead?.customerPhone}`" class="font-semibold text-blue-600 hover:underline">
                    {{ purchasedLead?.customerPhone }}
                  </a>
                </div>
                <div class="flex justify-between">
                  <span class="text-slate-500">현장</span>
                  <span class="font-medium text-slate-700">{{ purchasedLead?.propertyName }}</span>
                </div>
              </div>
            </div>

            <p class="text-sm text-slate-400 mb-4">
              고객에게 연락 후, "내 고객 보관함"에서 상담 내용을 기록해주세요.
            </p>
          </div>
          <div class="flex border-t border-slate-100">
            <button
              @click="closeSuccessModal"
              class="flex-1 py-4 text-slate-600 font-medium hover:bg-slate-50 transition"
            >
              닫기
            </button>
            <router-link
              to="/partners/leads/customers"
              class="flex-1 py-4 text-blue-600 font-semibold hover:bg-blue-50 transition text-center border-l border-slate-100"
            >
              내 고객 보관함
            </router-link>
          </div>
        </div>
      </div>
  </PartnersLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { collection, query, where, getDocs, doc, getDoc, runTransaction, and, or } from 'firebase/firestore'
import { db } from '@/firebase/firebase'
import { useAuth } from '@/composables/common/useAuth'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'

export default {
  name: 'BannerLeadsView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const { user } = useAuth()
    const loading = ref(true)
    const bannerLeads = ref([])
    const pointBalance = ref(0)
    const purchasing = ref(null)
    const showSuccessModal = ref(false)
    const purchasedLead = ref(null)

    const PURCHASE_PRICE = 10000

    const loadBannerLeads = async () => {
      if (!user.value) return

      try {
        loading.value = true

        // 광고 유입 콜 조회 (모든 광고 유형, status: 'banner_pending')
        const q = query(
          collection(db, 'consultationRequests'),
          and(
            where('partnerId', '==', user.value.uid),
            where('status', '==', 'banner_pending'),
            or(
              where('fromJump', '==', true),
              where('fromCampaign', '==', true),
              where('fromBanner', '==', true),
              where('fromAdBanner', '==', true),
              where('fromPopup', '==', true),
              where('fromSplash', '==', true),
              where('fromRecommendAd', '==', true),
              where('fromCommunityAd', '==', true),
              where('fromChatAd', '==', true)
            )
          )
        )

        const snapshot = await getDocs(q)
        bannerLeads.value = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      } catch (error) {
        console.error('광고 유입 콜 로드 실패:', error)
      } finally {
        loading.value = false
      }
    }

    const loadPointBalance = async () => {
      if (!user.value) return

      try {
        const pointDoc = await getDoc(doc(db, 'partnerPoints', user.value.uid))
        if (pointDoc.exists()) {
          pointBalance.value = pointDoc.data().balance || 0
        }
      } catch (error) {
        console.error('포인트 잔액 로드 실패:', error)
      }
    }

    // 광고 유형별 스타일 헬퍼 함수들
    const getLeadHeaderClass = (lead) => {
      if (lead.fromJump) return 'bg-blue-50 border-blue-100'
      if (lead.fromCampaign) return 'bg-indigo-50 border-indigo-100'
      if (lead.fromSplash) return 'bg-cyan-50 border-cyan-100'
      if (lead.fromPopup) return 'bg-rose-50 border-rose-100'
      if (lead.fromAdBanner) return 'bg-violet-50 border-violet-100'
      if (lead.fromRecommendAd) return 'bg-orange-50 border-orange-100'
      if (lead.fromCommunityAd) return 'bg-slate-50 border-slate-200'
      if (lead.fromChatAd) return 'bg-emerald-50 border-emerald-100'
      return 'bg-amber-50 border-amber-100'
    }

    const getLeadBadgeClass = (lead) => {
      if (lead.fromJump) return 'bg-blue-500'
      if (lead.fromCampaign) return 'bg-indigo-500'
      if (lead.fromSplash) return 'bg-cyan-500'
      if (lead.fromPopup) return 'bg-rose-500'
      if (lead.fromAdBanner) return 'bg-violet-500'
      if (lead.fromRecommendAd) return 'bg-orange-500'
      if (lead.fromCommunityAd) return 'bg-slate-500'
      if (lead.fromChatAd) return 'bg-emerald-500'
      return 'bg-amber-500'
    }

    const getLeadBadgeText = (lead) => {
      if (lead.fromJump) return 'JUMP'
      if (lead.fromCampaign) return 'CAMPAIGN'
      if (lead.fromSplash) return 'SPLASH'
      if (lead.fromPopup) return 'POPUP'
      if (lead.fromAdBanner) return 'IN-APP'
      if (lead.fromRecommendAd) return 'RECOMMEND'
      if (lead.fromCommunityAd) return 'COMMUNITY'
      if (lead.fromChatAd) return 'CHAT AD'
      return 'BANNER'
    }

    const getLeadTextClass = (lead) => {
      if (lead.fromJump) return 'text-blue-700'
      if (lead.fromCampaign) return 'text-indigo-700'
      if (lead.fromSplash) return 'text-cyan-700'
      if (lead.fromPopup) return 'text-rose-700'
      if (lead.fromAdBanner) return 'text-violet-700'
      if (lead.fromRecommendAd) return 'text-orange-700'
      if (lead.fromCommunityAd) return 'text-slate-700'
      if (lead.fromChatAd) return 'text-emerald-700'
      return 'text-amber-700'
    }

    const getLeadLabelClass = (lead) => {
      if (lead.fromJump) return 'text-blue-600'
      if (lead.fromCampaign) return 'text-indigo-600'
      if (lead.fromSplash) return 'text-cyan-600'
      if (lead.fromPopup) return 'text-rose-600'
      if (lead.fromAdBanner) return 'text-violet-600'
      if (lead.fromRecommendAd) return 'text-orange-600'
      if (lead.fromCommunityAd) return 'text-slate-600'
      if (lead.fromChatAd) return 'text-emerald-600'
      return 'text-amber-600'
    }

    const getLeadLabel = (lead) => {
      if (lead.fromJump) return '점프 상단노출 유입'
      if (lead.fromCampaign) return '캠페인 링크 유입'
      if (lead.fromSplash) return '스플래시 광고 유입'
      if (lead.fromPopup) return '팝업 광고 유입'
      if (lead.fromAdBanner) return '인앱 광고 유입'
      if (lead.fromRecommendAd) return '추천 광고 유입'
      if (lead.fromCommunityAd) return '커뮤니티 광고 유입'
      if (lead.fromChatAd) return '꾸우챗 광고 유입'
      return '메인 배너 유입'
    }

    const maskName = (name) => {
      if (!name || name.length < 2) return '***'
      return name.charAt(0) + '*'.repeat(name.length - 1)
    }

    const maskPhone = (phone) => {
      if (!phone) return '***-****-****'
      const parts = phone.split('-')
      if (parts.length === 3) {
        return `${parts[0]}-****-${parts[2].slice(-2)}**`
      }
      return '***-****-****'
    }

    const formatDate = (dateStr) => {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('ko-KR', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    const purchaseLead = async (lead) => {
      if (!user.value || purchasing.value || pointBalance.value < PURCHASE_PRICE) return

      if (!confirm(`이 콜을 ${PURCHASE_PRICE.toLocaleString()}P에 구매하시겠습니까?`)) return

      purchasing.value = lead.id

      try {
        const now = new Date().toISOString()

        // 트랜잭션으로 포인트 차감 + 콜 상태 변경
        await runTransaction(db, async (transaction) => {
          // 포인트 문서 조회
          const pointRef = doc(db, 'partnerPoints', user.value.uid)
          const pointDoc = await transaction.get(pointRef)

          if (!pointDoc.exists()) {
            throw new Error('포인트 정보가 없습니다.')
          }

          const currentBalance = pointDoc.data().balance || 0
          if (currentBalance < PURCHASE_PRICE) {
            throw new Error('포인트가 부족합니다.')
          }

          // 포인트 차감
          transaction.update(pointRef, {
            balance: currentBalance - PURCHASE_PRICE,
            totalUsed: (pointDoc.data().totalUsed || 0) + PURCHASE_PRICE,
            updatedAt: now
          })

          // 콜 상태 변경 (banner_pending -> contacted)
          const leadRef = doc(db, 'consultationRequests', lead.id)
          transaction.update(leadRef, {
            status: 'contacted',
            contactedAt: now,
            updatedAt: now,
            purchasedAt: now,
            purchasePrice: PURCHASE_PRICE
          })

          // 포인트 거래 내역 추가
          const transactionRef = doc(collection(db, 'pointTransactions'))
          const getAdTypeLabel = () => {
            if (lead.fromJump) return '점프'
            if (lead.fromCampaign) return '캠페인'
            if (lead.fromSplash) return '스플래시 광고'
            if (lead.fromPopup) return '팝업 광고'
            if (lead.fromAdBanner) return '인앱 광고'
            if (lead.fromRecommendAd) return '추천 광고'
            if (lead.fromCommunityAd) return '커뮤니티 광고'
            if (lead.fromChatAd) return '꾸우챗 광고'
            return '메인 배너'
          }
          const adTypeLabel = getAdTypeLabel()
          transaction.set(transactionRef, {
            partnerId: user.value.uid,
            type: 'use',
            amount: -PURCHASE_PRICE,
            balanceAfter: currentBalance - PURCHASE_PRICE,
            description: `${adTypeLabel} 콜 구매 - ${lead.propertyName}`,
            relatedId: lead.id,
            createdAt: now
          })
        })

        // 성공 처리
        purchasedLead.value = lead
        showSuccessModal.value = true

        // 목록에서 제거
        bannerLeads.value = bannerLeads.value.filter(l => l.id !== lead.id)

        // 포인트 잔액 업데이트
        pointBalance.value -= PURCHASE_PRICE
      } catch (error) {
        console.error('콜 구매 실패:', error)
        alert('구매에 실패했습니다: ' + error.message)
      } finally {
        purchasing.value = null
      }
    }

    const closeSuccessModal = () => {
      showSuccessModal.value = false
      purchasedLead.value = null
    }

    onMounted(async () => {
      await Promise.all([
        loadBannerLeads(),
        loadPointBalance()
      ])
    })

    return {
      loading,
      bannerLeads,
      pointBalance,
      purchasing,
      showSuccessModal,
      purchasedLead,
      getLeadHeaderClass,
      getLeadBadgeClass,
      getLeadBadgeText,
      getLeadTextClass,
      getLeadLabelClass,
      getLeadLabel,
      maskName,
      maskPhone,
      formatDate,
      purchaseLead,
      closeSuccessModal
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-10 h-10 border-4 border-amber-500 border-t-transparent rounded-full animate-spin;
}
</style>
